export const translations = {
  en: {
    "announcement.text": "",
    "brand.name": "MUSLIMAH CANTIK",
    "brand.tagline": "Modest fashion & halal skincare",
    "nav.home": "Home",
    "nav.womenMuslimah": "Women Muslimah",
    "nav.apparel": "Apparel",
    "nav.skincare": "Skincare",
    "header.searchPlaceholder": "Search products",
    "header.account": "Account",
    "header.wishlist": "Wishlist",
    "header.cart": "Cart",
    "header.openMenu": "Open menu",
    "header.closeMenu": "Close",
    "header.language": "Language",
    "footer.shop": "Shop",
    "footer.help": "Help",
    "footer.about": "About",
    "footer.rights": "© 2026 MUSLIMAH CANTIK. All rights reserved.",
    "footer.description": "A modern marketplace for modest fashion and tropical halal skincare.",
    "footer.link.newArrivals": "New Arrivals",
    "footer.link.bestSellers": "Best Sellers",
    "footer.link.contact": "Contact Us",
    "footer.link.shipping": "Shipping",
    "footer.link.returns": "Returns & Exchanges",
    "footer.link.faq": "FAQ",
    "footer.link.aboutUs": "About Us",
    "footer.link.stores": "Our Stores",
    "footer.link.privacy": "Privacy Policy",
    "footer.link.terms": "Terms & Conditions",
    "common.loading": "Loading…",
    "common.error": "Something went wrong",
    "common.retry": "Try again",
    "common.empty": "Nothing here yet",
    "common.comingSoon": "This section is coming soon.",
    "common.close": "Close",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.back": "Back",
    "common.submit": "Submit",
    "validation.required": "This field is required",
    "validation.email": "Enter a valid email address",
    "validation.minLength": "Too short",
    "validation.maxLength": "Too long",
    "errors.generic": "An unexpected error occurred.",
    "errors.network": "Network error. Please check your connection.",
    "errors.notFound": "Page not found.",
    "page.home.heroTitle": "The Modest Edit — Fall-Winter 2026",
    "page.home.heroSubtitle": "New arrivals across women muslimah wear, everyday apparel, and tropical halal skincare.",
    "page.home.placeholderNote": "Storefront modules are on the way.",
    "nav.newArrivals": "New Arrivals",
    "nav.bestSellers": "Best Sellers",
    "nav.sale": "Sale",
    "nav.uniqloProducts": "UNIQLO Products",
    "search.browseCategories": "Browse Categories",
    "home.shopByCategory": "Shop by Category",
    "home.shopByDepartment": "Shop by Department",
    "home.newArrivals": "New Arrivals",
    "home.bestSellers": "Best Sellers",
    "home.viewAll": "View All",
    "home.shopNow": "Shop Now",
    "home.allDepartments": "All Departments",
    "home.deptCta": "Discover",
    "plp.results": "Results: {count} items",
    "plp.sortBy": "Sort by",
    "plp.filter": "Filter",
    "product.new": "NEW",
    "product.sale": "SALE",
    "product.catalog": "CATALOG",
    "product.catalogLabel": "Pre-order",
    "preorder.label": "Pre-order · estimated 2–3 weeks",
    "preorder.sizeAvailability": "Size depends on stock availability at the time of order",
    "preorder.sizeAvailabilityShort": "Size availability depends on stock at the time of order",
    "product.wishlist": "Add to wishlist",
    "footer.account": "Account",
    "footer.link.myAccount": "My Account",
    "footer.link.orders": "Orders",
    "footer.promo": "",
    "editorial.title": "Stories & Guides",
    "editorial.cta": "Learn More",
    "page.title.search": "Search",
    "page.title.shop": "Shop",
    "plp.filters": "Filters",
    "plp.price": "Price",
    "plp.minPrice": "Min",
    "plp.maxPrice": "Max",
    "plp.apply": "Apply",
    "plp.color": "Color",
    "plp.size": "Size",
    "plp.volume": "Volume",
    "plp.motif": "Motif",
    "plp.format": "Format",
    "plp.availability": "Ordering mode",
    "plp.inStock": "Pre-order",
    "plp.clearFilters": "Clear all",
    "plp.noResults": "No products match your filters.",
    "plp.noProducts": "This collection is being prepared.",
    "plp.noProductsHint": "Browse the categories above. Products will appear here once the collection is ready.",
    "plp.noResultsHint": "Try removing a filter or choosing different options.",
    "plp.pageOf": "Page {page} of {pages}",
    "plp.prev": "Previous",
    "plp.next": "Next",
    "sort.featured": "Featured",
    "sort.newest": "Newest",
    "sort.priceAsc": "Price: Low to High",
    "sort.priceDesc": "Price: High to Low",
    "product.outOfStock": "Pre-order available",
    "product.lowStock": "Pre-order available",
    "search.resultsFor": "Results for \"{q}\"",
    "search.noResults": "No results found. Try a different search term.",
    "search.resultsCount": "{count} products",
    "page.title.product": "Product",
    "pdp.quantity": "Quantity",
    "pdp.addToCart": "Add to Cart",
    "pdp.addToWishlist": "Add to Wishlist",
    "pdp.catalogNotice": "Pre-order · estimated 2–3 weeks",
    "pdp.sizeGuide": "Size Guide",
    "pdp.sizeGuideNote": "Measurements in cm. If you are between sizes, we recommend sizing up.",
    "pdp.chest": "Chest",
    "pdp.length": "Length",
    "options.color": "Color",
    "options.size": "Size",
    "options.material": "Material",
    "options.volume": "Volume",
    "options.motif": "Motif",
    "options.format": "Format",
    "product.inStock": "Pre-order · estimated 2–3 weeks",
    "pdp.onlyLeft": "Pre-order · estimated 2–3 weeks",
    "pdp.description": "Description",
    "pdp.features": "Features",
    "pdp.materialCare": "Material & Care",
    "pdp.details": "Product Details",
    "pdp.ingredients": "Ingredients",
    "pdp.benefits": "Benefits",
    "pdp.directions": "How to Use",
    "pdp.fragrance": "Fragrance",
    "pdp.fragranceFamily": "Fragrance family",
    "pdp.notes": "Notes",
    "pdp.usage": "How to wear",
    "pdp.alcoholFree": "Alcohol-free formula",
    "pdp.motif": "Motif",
    "pdp.halalCertified": "Halal Certified",
    "pdp.skinType": "Skin Type",
    "pdp.sku": "SKU",
    "pdp.selectionReady": "Variant selected — cart checkout arrives in the next milestone.",
    "auth.login": "Sign In",
    "auth.register": "Create Account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.firstName": "First Name",
    "auth.lastName": "Last Name",
    "auth.forgot": "Forgot password?",
    "auth.noAccount": "No account yet?",
    "auth.haveAccount": "Already have an account?",
    "auth.logout": "Log Out",
    "auth.forgotTitle": "Reset Password",
    "auth.forgotText": "Enter your account email and we will send a reset link.",
    "auth.forgotSent": "If that email is registered, a reset link has been sent.",
    "auth.sendLink": "Send Reset Link",
    "auth.resetTitle": "Choose a New Password",
    "auth.newPassword": "New Password",
    "auth.resetCta": "Reset Password",
    "auth.resetDone": "Password updated. You can sign in now.",
    "auth.backToLogin": "Back to Sign In",
    "auth.invalidCredentials": "Invalid email or password.",
    "auth.adminOnly": "This account must sign in through the Admin Console.",
    "auth.customerOnly": "This account cannot sign in to the customer store.",
    "auth.sessionExpired": "Your session expired. Please sign in again.",
    "auth.emailExists": "An account with this email already exists.",
    "auth.tooMany": "Too many attempts. Please try again later.",
    "auth.invalidReset": "This reset link is invalid or has expired.",
    "auth.genericError": "Something went wrong. Please try again.",
    "auth.account": "My Account",
    "auth.profile": "Profile",
    "auth.addresses": "Addresses",
    "auth.addAddress": "Add Address",
    "auth.setDefault": "Set as Default",
    "auth.defaultBadge": "Default",
    "auth.label": "Label",
    "auth.recipient": "Recipient Name",
    "auth.phone": "Phone",
    "auth.addressLine1": "Address Line 1",
    "auth.addressLine2": "Address Line 2 (optional)",
    "auth.city": "City",
    "auth.province": "Province / State",
    "auth.postalCode": "Postal Code",
    "auth.country": "Country Code",
    "auth.localeLabel": "Preferred Language",
    "auth.profileSaved": "Profile updated.",
    "auth.addressSaved": "Address saved.",
    "auth.addressDeleted": "Address deleted.",
    "auth.loginRequired": "Please sign in to view your account.",
    "auth.noAddresses": "No addresses saved yet.",
    "auth.memberSince": "Member since",
    "cart.title": "Shopping Cart",
    "cart.empty": "Your cart is empty",
    "cart.emptyHint": "Browse our departments and add something you love.",
    "cart.emptyCta": "Continue Shopping",
    "cart.subtotal": "Subtotal",
    "cart.remove": "Remove",
    "cart.checkout": "Proceed to Checkout",
    "cart.checkoutUnavailable": "Online purchase unavailable",
    "cart.checkoutUnavailableBody": "You can add items to your cart and review quantities. Online checkout is not available yet.",
    "cart.shippingNote": "Shipping will be confirmed by our admin in Telegram.",
    "cart.confirm": "Confirm",
    "cart.confirmNote": "This sends a cart inquiry to our Telegram store chat. Tap Send in Telegram to submit. This is not a final order.",
    "cart.confirmUnavailable": "Telegram cart inquiries are not available right now. Please try again later.",
    "cart.confirmFailed": "We couldn't confirm whether the Telegram inquiry was prepared. Refresh the cart and try again.",
    "cart.confirmCartChanged": "The server cart no longer has these items. We've refreshed it; add the products again if you still want to order.",
    "cart.confirmRateLimited": "Too many attempts. Please wait a moment before trying again.",
    "cart.added": "Added to cart",
    "cart.exceedsStock": "Pre-order · estimated 2–3 weeks",
    "cart.demoQuantityLimit": "Maximum {count} items per product.",
    "cart.quantityLimit": "Maximum {count} items per product.",
    "cart.sizeNoLongerAvailable": "This size is no longer available for new orders. The item already in your cart can still be submitted.",
    "cart.mergeAdjusted": "Your guest cart was merged.",
    "cart.mergeFailed": "We couldn't merge your guest cart yet. It is preserved; try again here.",
    "cart.mergePending": "We're finishing the cart merge. Please wait before changing items.",
    "wishlist.title": "My Wishlist",
    "wishlist.empty": "Your wishlist is empty",
    "wishlist.emptyHint": "Tap the heart on any product to save it here.",
    "wishlist.added": "Added to wishlist",
    "wishlist.removed": "Removed from wishlist",
    "wishlist.loginRequired": "Sign in to save items to your wishlist.",
    "wishlist.saveAfterLoginFailed": "You signed in, but this item wasn't saved. Please try again.",
    "checkout.title": "Checkout",
    "checkout.contact": "Contact",
    "checkout.email": "Email",
    "checkout.shippingAddress": "Shipping Address",
    "checkout.savedAddresses": "Saved addresses",
    "checkout.newAddress": "Use a new address",
    "checkout.shippingMethod": "Shipping Method",
    "checkout.paymentMethod": "Payment Method",
    "checkout.orderSummary": "Order Summary",
    "checkout.subtotal": "Subtotal",
    "checkout.shipping": "Shipping",
    "checkout.free": "Free",
    "checkout.total": "Total",
    "checkout.placeOrder": "Place Order",
    "checkout.placing": "Placing order…",
    "checkout.empty": "Your cart is empty",
    "checkout.emptyCta": "Back to Cart",
    "checkout.etaDays": "{days} business days",
    "checkout.stockError": "Some items are no longer available. Please review your cart.",
    "checkout.failed": "Could not place the order. Please try again.",
    "checkout.disabledTitle": "Online purchase is not available yet",
    "checkout.disabledBody": "The storefront is live, but checkout is temporarily unavailable while payment setup is completed. No order or payment will be created.",
    "checkout.disabledCta": "Back to the shop",
    "pdp.checkoutUnavailable": "Coming soon",
    "paymentPending.title": "Payment is being confirmed",
    "paymentPending.body": "Your order is reserved while we wait for the payment provider. This page checks the status automatically.",
    "paymentPending.failedTitle": "Payment was not completed",
    "paymentPending.failedBody": "No successful payment was recorded. You can return to the shop and try again.",
    "paymentPending.invalidTitle": "Order status unavailable",
    "paymentPending.invalidBody": "This payment status link is invalid or has expired.",
    "confirm.title": "Order confirmed",
    "confirm.thanks": "Thank you! Your order is confirmed.",
    "confirm.orderNumber": "Order number",
    "confirm.totalPaid": "Total paid",
    "confirm.emailNote": "A confirmation was logged for {email} (mock email in development).",
    "confirm.saveLink": "Bookmark this page to revisit your order status.",
    "confirm.continue": "Continue Shopping",
    "confirm.viewOrders": "View My Orders",
    "orders.title": "My Orders",
    "orders.empty": "No orders yet",
    "orders.emptyHint": "Your completed orders will appear here.",
    "orders.items": "{count} items",
    "orders.detailTitle": "Order",
    "orders.paymentState": "Payment",
    "orders.orderStatus": "Status",
    "orders.shippingAddress": "Shipping Address",
    "orders.shippingMethod": "Shipping Method",
    "orders.subtotal": "Subtotal",
    "orders.shipping": "Shipping",
    "orders.total": "Total",
    "orders.backToOrders": "Back to orders",
    "orders.state.pending_payment": "Awaiting payment",
    "orders.state.paid": "Pre-order processing",
    "orders.state.cancelled": "Cancelled",
    "orders.state.processing": "Processing",
    "orders.state.shipped": "Shipped",
    "orders.state.delivered": "Delivered",
    "orders.pay.unpaid": "Unpaid",
    "orders.pay.paid": "Paid",
    "orders.pay.failed": "Failed",
    "orders.pay.cancelled": "Cancelled",
    "orders.pay.expired": "Expired",
    "orders.pay.refunded": "Refunded",
    "orders.pay.review": "Under review",
    "orders.pay.reconciliation_required": "Needs review",
    "paymentPending.reviewTitle": "Payment needs review",
    "paymentPending.reviewBody": "The provider reported a payment that needs manual reconciliation. We will update this order after verification.",
    "orders.state.payment_review": "Payment review",
    "orders.state.supplier_shipping": "Shipping to store admin",
    "orders.state.received_by_admin": "Received by store admin",
    "orders.state.customer_shipping": "Shipped to you",
    "orders.timeline": "Order progress",
    "orders.expectedBy": "Expected by",
    "seller.portal": "Seller Portal",
    "seller.backToStore": "View Store",
    "seller.forbidden": "This area is for seller accounts only.",
    "seller.nav.dashboard": "Dashboard",
    "seller.nav.products": "PRODUCTS",
    "seller.nav.productsList": "Products",
    "seller.nav.inventory": "Inventory",
    "seller.nav.orders": "ORDERS",
    "seller.nav.ordersList": "Orders",
    "seller.nav.account": "ACCOUNT",
    "seller.nav.profile": "Seller Profile",
    "seller.dashboard.title": "Dashboard",
    "seller.dashboard.activeProducts": "Active products",
    "seller.dashboard.lowStock": "Low stock variants",
    "seller.dashboard.outOfStock": "Out of stock",
    "seller.dashboard.needsAction": "Items needing action",
    "seller.dashboard.salesTotal": "Sales total (order items)",
    "seller.dashboard.salesOrders": "Paid orders",
    "seller.dashboard.salesNote": "Order-item totals, not a withdrawable balance.",
    "seller.dashboard.recentOrders": "Recent orders",
    "seller.dashboard.viewAll": "View all",
    "seller.dashboard.paymentReview": "Payments",
    "seller.dashboard.openInquiries": "Open inquiries",
    "seller.dashboard.preordersInProgress": "Pre-orders in progress",
    "seller.dashboard.ordersByStatus": "Workflow status",
    "seller.dashboard.order": "Order",
    "seller.dashboard.date": "Date",
    "seller.dashboard.status": "Status",
    "seller.dashboard.payment": "Payment",
    "seller.dashboard.total": "Total",
    "seller.dashboard.noRecentOrders": "No recent orders.",
    "seller.dashboard.errorTitle": "Dashboard failed to load",
    "seller.dashboard.errorDescription": "The dashboard data could not be loaded. Your catalog and orders are unchanged.",
    "seller.dashboard.retry": "Try again",
    "seller.dashboard.status.inquiry": "Inquiry",
    "seller.dashboard.status.payment": "Payment",
    "seller.dashboard.status.pending_payment": "Awaiting payment",
    "seller.dashboard.status.payment_review": "Payment review",
    "seller.dashboard.status.paid": "Paid",
    "seller.dashboard.status.supplier_shipping": "Supplier shipping",
    "seller.dashboard.status.received_by_admin": "Received by admin",
    "seller.dashboard.status.customer_shipping": "Customer shipping",
    "seller.dashboard.status.delivered": "Completed",
    "seller.products.title": "Products",
    "seller.products.new": "New Product",
    "seller.products.searchPlaceholder": "Search your products…",
    "seller.products.status": "Status",
    "seller.products.allStatuses": "All statuses",
    "seller.products.inventory": "Inventory",
    "seller.products.allInventory": "All inventory",
    "seller.products.empty": "No products found.",
    "seller.products.product": "Product",
    "seller.products.price": "Price",
    "seller.products.variants": "Variants",
    "seller.products.stock": "Stock",
    "seller.products.edit": "Edit",
    "seller.products.prev": "Previous",
    "seller.products.next": "Next",
    "seller.stock.in_stock": "In Stock",
    "seller.stock.low_stock": "Low Stock",
    "seller.stock.out_of_stock": "Out of Stock",
    "seller.status.active": "Active",
    "seller.status.draft": "Draft",
    "seller.status.inactive": "Inactive",
    "seller.editor.backToProducts": "Back to products",
    "seller.editor.createTitle": "New Product",
    "seller.editor.editTitle": "Edit Product",
    "seller.editor.basics": "Basics",
    "seller.editor.category": "Category",
    "seller.editor.type": "Product type",
    "seller.editor.brand": "Brand",
    "seller.editor.basePrice": "Base price",
    "seller.editor.compareAt": "Compare-at price",
    "seller.editor.status": "Status",
    "seller.editor.imageUrl": "Image URL",
    "seller.editor.mediaHint": "Upload product images here; they are stored in the local CMS media library.",
    "seller.editor.translations": "Translations",
    "seller.editor.name": "Name",
    "seller.editor.shortDesc": "Short description",
    "seller.editor.description": "Description",
    "seller.editor.variants": "Variants",
    "seller.editor.addVariant": "Add variant",
    "seller.editor.optionsHint": "Options as key=value pairs, comma-separated (e.g. color=Black, size=M or volume=50 ml).",
    "seller.editor.sku": "SKU",
    "seller.editor.options": "Options",
    "seller.editor.stock": "Stock",
    "seller.editor.priceOverride": "Price override",
    "seller.editor.saleOverride": "Sale price",
    "seller.editor.active": "Active",
    "seller.editor.save": "Save",
    "seller.editor.saving": "Saving…",
    "seller.editor.saved": "Product saved.",
    "seller.editor.failed": "Could not save. Please try again.",
    "seller.editor.skuExists": "That SKU is already in use. SKUs must be globally unique.",
    "seller.editor.reservationFloor": "Cannot set stock below {count} — active checkout reservations exist.",
    "seller.editor.archive": "Archive",
    "seller.editor.archived": "Product archived.",
    "seller.inventory.title": "Inventory",
    "seller.inventory.hint": "Physical stock only. Active checkout reservations are system-controlled and cannot be edited.",
    "seller.inventory.physical": "Physical",
    "seller.inventory.reserved": "Reserved",
    "seller.inventory.available": "Available",
    "seller.inventory.save": "Save",
    "seller.inventory.updated": "Stock updated.",
    "seller.inventory.failed": "Could not update stock.",
    "seller.inventory.floorError": "Cannot go below {count} — active checkout reservations.",
    "seller.orders.title": "Orders",
    "seller.orders.allFulfillments": "All fulfillment states",
    "seller.orders.order": "Order",
    "seller.orders.date": "Date",
    "seller.orders.recipient": "Recipient",
    "seller.orders.items": "Items",
    "seller.orders.payment": "Payment",
    "seller.orders.fulfillment": "Fulfillment",
    "seller.orders.subtotal": "Your subtotal",
    "seller.orders.empty": "No orders yet.",
    "seller.fulfillment.pending": "Pending",
    "seller.fulfillment.processing": "Processing",
    "seller.fulfillment.shipped": "Shipped",
    "seller.fulfillment.delivered": "Delivered",
    "seller.fulfillment.cancelled": "Cancelled",
    "seller.orderDetail.items": "Your items",
    "seller.orderDetail.actions": "Fulfillment",
    "seller.orderDetail.blockedUnpaid": "Payment not confirmed — fulfillment is blocked until the order is paid.",
    "seller.orderDetail.mark_processing": "Start processing",
    "seller.orderDetail.mark_shipped": "Mark shipped",
    "seller.orderDetail.mark_delivered": "Mark delivered",
    "seller.orderDetail.noActions": "No further actions.",
    "seller.orderDetail.carrier": "Carrier",
    "seller.orderDetail.trackingNumber": "Tracking number",
    "seller.orderDetail.customer": "Recipient & delivery",
    "seller.orderDetail.updated": "Fulfillment updated.",
    "seller.orderDetail.invalidTransition": "That status change is not allowed.",
    "seller.orderDetail.failed": "Action failed. Please try again.",
    "seller.profile.title": "Seller Profile",
    "seller.profile.storeName": "Store name",
    "seller.profile.phone": "Contact phone",
    "seller.profile.description": "Store description",
    "seller.profile.email": "Account email",
    "seller.profile.slug": "Store slug",
    "seller.profile.memberSince": "Member since",
    "seller.profile.save": "Save profile",
    "seller.profile.saved": "Profile saved.",
    "page.title.cart": "Cart",
    "page.title.wishlist": "Wishlist",
    "page.title.account": "Account",
    "page.title.checkout": "Checkout",
    "page.title.seller": "Seller",
    "page.title.admin": "Admin",
  },
  id: {
    "announcement.text": "",
    "brand.name": "MUSLIMAH CANTIK",
    "brand.tagline": "Busana muslimah & skincare halal",
    "nav.home": "Beranda",
    "nav.womenMuslimah": "Busana Muslimah",
    "nav.apparel": "Pakaian",
    "nav.skincare": "Perawatan Kulit",
    "header.searchPlaceholder": "Cari produk",
    "header.account": "Akun",
    "header.wishlist": "Wishlist",
    "header.cart": "Keranjang",
    "header.openMenu": "Buka menu",
    "header.closeMenu": "Tutup",
    "header.language": "Bahasa",
    "footer.shop": "Belanja",
    "footer.help": "Bantuan",
    "footer.about": "Tentang",
    "footer.rights": "© 2026 MUSLIMAH CANTIK. Seluruh hak cipta dilindungi.",
    "footer.description": "Marketplace modern untuk busana muslimah dan skincare halal tropis.",
    "footer.link.newArrivals": "Koleksi Terbaru",
    "footer.link.bestSellers": "Terlaris",
    "footer.link.contact": "Hubungi Kami",
    "footer.link.shipping": "Pengiriman",
    "footer.link.returns": "Pengembalian & Penukaran",
    "footer.link.faq": "FAQ",
    "footer.link.aboutUs": "Tentang Kami",
    "footer.link.stores": "Toko Kami",
    "footer.link.privacy": "Kebijakan Privasi",
    "footer.link.terms": "Syarat & Ketentuan",
    "common.loading": "Memuat…",
    "common.error": "Terjadi kesalahan",
    "common.retry": "Coba lagi",
    "common.empty": "Belum ada apa-apa di sini",
    "common.comingSoon": "Bagian ini segera hadir.",
    "common.close": "Tutup",
    "common.edit": "Ubah",
    "common.delete": "Hapus",
    "common.cancel": "Batal",
    "common.save": "Simpan",
    "common.back": "Kembali",
    "common.submit": "Kirim",
    "validation.required": "Wajib diisi",
    "validation.email": "Masukkan alamat email yang valid",
    "validation.minLength": "Terlalu pendek",
    "validation.maxLength": "Terlalu panjang",
    "errors.generic": "Terjadi kesalahan tak terduga.",
    "errors.network": "Kesalahan jaringan. Periksa koneksi Anda.",
    "errors.notFound": "Halaman tidak ditemukan.",
    "page.home.heroTitle": "Koleksi Muslimah — Musim Gugur-Dingin 2026",
    "page.home.heroSubtitle": "Koleksi terbaru busana muslimah, pakaian sehari-hari, dan skincare halal tropis.",
    "page.home.placeholderNote": "Modul etalase akan segera hadir.",
    "nav.newArrivals": "Koleksi Terbaru",
    "nav.bestSellers": "Terlaris",
    "nav.sale": "Promo",
    "nav.uniqloProducts": "Produk UNIQLO",
    "search.browseCategories": "Jelajahi Kategori",
    "home.shopByCategory": "Belanja per Kategori",
    "home.shopByDepartment": "Belanja berdasarkan Department",
    "home.newArrivals": "Koleksi Terbaru",
    "home.bestSellers": "Terlaris",
    "home.viewAll": "Lihat Semua",
    "home.shopNow": "Belanja Sekarang",
    "home.allDepartments": "Semua Departemen",
    "home.deptCta": "Jelajahi",
    "plp.results": "Hasil: {count} produk",
    "plp.sortBy": "Urutkan",
    "plp.filter": "Filter",
    "product.new": "BARU",
    "product.sale": "PROMO",
    "product.catalog": "KATALOG",
    "product.catalogLabel": "Pre-order",
    "preorder.label": "Pre-order · estimasi 2–3 minggu",
    "preorder.sizeAvailability": "Size tergantung pada ketersediaan stok pada saat order",
    "preorder.sizeAvailabilityShort": "Ketersediaan ukuran tergantung pada stok saat order",
    "product.wishlist": "Tambah ke wishlist",
    "footer.account": "Akun",
    "footer.link.myAccount": "Akun Saya",
    "footer.link.orders": "Pesanan",
    "footer.promo": "",
    "editorial.title": "Cerita & Panduan",
    "editorial.cta": "Pelajari Lebih Lanjut",
    "page.title.search": "Pencarian",
    "page.title.shop": "Belanja",
    "plp.filters": "Filter",
    "plp.price": "Harga",
    "plp.minPrice": "Min",
    "plp.maxPrice": "Maks",
    "plp.apply": "Terapkan",
    "plp.color": "Warna",
    "plp.size": "Ukuran",
    "plp.volume": "Volume",
    "plp.motif": "Motif",
    "plp.format": "Format",
    "plp.availability": "Mode pemesanan",
    "plp.inStock": "Pre-order",
    "plp.clearFilters": "Hapus semua",
    "plp.noResults": "Tidak ada produk yang cocok dengan filter.",
    "plp.noProducts": "Koleksi sedang dipersiapkan.",
    "plp.noProductsHint": "Jelajahi kategori di atas. Produk akan muncul setelah koleksi siap.",
    "plp.noResultsHint": "Coba hapus filter atau pilih opsi lain.",
    "plp.pageOf": "Halaman {page} dari {pages}",
    "plp.prev": "Sebelumnya",
    "plp.next": "Berikutnya",
    "sort.featured": "Unggulan",
    "sort.newest": "Terbaru",
    "sort.priceAsc": "Harga: Rendah ke Tinggi",
    "sort.priceDesc": "Harga: Tinggi ke Rendah",
    "product.outOfStock": "Tersedia melalui pre-order",
    "product.lowStock": "Tersedia melalui pre-order",
    "search.resultsFor": "Hasil untuk \"{q}\"",
    "search.noResults": "Tidak ada hasil. Coba kata kunci lain.",
    "search.resultsCount": "{count} produk",
    "page.title.product": "Produk",
    "pdp.quantity": "Jumlah",
    "pdp.addToCart": "Tambah ke Keranjang",
    "pdp.addToWishlist": "Tambah ke Wishlist",
    "pdp.catalogNotice": "Pre-order · estimasi 2–3 minggu",
    "pdp.sizeGuide": "Panduan Ukuran",
    "pdp.sizeGuideNote": "Ukuran dalam cm. Jika di antara dua ukuran, kami sarankan pilih yang lebih besar.",
    "pdp.chest": "Dada",
    "pdp.length": "Panjang",
    "options.color": "Warna",
    "options.size": "Ukuran",
    "options.material": "Bahan",
    "options.volume": "Volume",
    "options.motif": "Motif",
    "options.format": "Format",
    "product.inStock": "Pre-order · estimasi 2–3 minggu",
    "pdp.onlyLeft": "Pre-order · estimasi 2–3 minggu",
    "pdp.description": "Deskripsi",
    "pdp.features": "Fitur",
    "pdp.materialCare": "Bahan & Perawatan",
    "pdp.details": "Detail Produk",
    "pdp.ingredients": "Komposisi",
    "pdp.benefits": "Manfaat",
    "pdp.directions": "Cara Pakai",
    "pdp.fragrance": "Aroma",
    "pdp.fragranceFamily": "Keluarga aroma",
    "pdp.notes": "Notes",
    "pdp.usage": "Cara pakai",
    "pdp.alcoholFree": "Formula bebas alkohol",
    "pdp.motif": "Motif",
    "pdp.halalCertified": "Bersertifikat Halal",
    "pdp.skinType": "Jenis Kulit",
    "pdp.sku": "SKU",
    "pdp.selectionReady": "Varian dipilih — checkout keranjang hadir di milestone berikutnya.",
    "auth.login": "Masuk",
    "auth.register": "Buat Akun",
    "auth.email": "Email",
    "auth.password": "Kata Sandi",
    "auth.firstName": "Nama Depan",
    "auth.lastName": "Nama Belakang",
    "auth.forgot": "Lupa kata sandi?",
    "auth.noAccount": "Belum punya akun?",
    "auth.haveAccount": "Sudah punya akun?",
    "auth.logout": "Keluar",
    "auth.forgotTitle": "Atur Ulang Kata Sandi",
    "auth.forgotText": "Masukkan email akun Anda dan kami akan mengirim tautan atur ulang.",
    "auth.forgotSent": "Jika email terdaftar, tautan atur ulang telah dikirim.",
    "auth.forgotSentShort": "Tautan terkirim jika email terdaftar.",
    "auth.sendLink": "Kirim Tautan",
    "auth.resetTitle": "Buat Kata Sandi Baru",
    "auth.newPassword": "Kata Sandi Baru",
    "auth.resetCta": "Atur Ulang Kata Sandi",
    "auth.resetDone": "Kata sandi diperbarui. Silakan masuk.",
    "auth.backToLogin": "Kembali ke Masuk",
    "auth.invalidCredentials": "Email atau kata sandi salah.",
    "auth.adminOnly": "Akun ini harus masuk melalui Admin Console.",
    "auth.customerOnly": "Akun ini tidak memiliki akses ke toko pelanggan.",
    "auth.sessionExpired": "Sesi Anda berakhir. Silakan masuk kembali.",
    "auth.emailExists": "Akun dengan email ini sudah terdaftar.",
    "auth.tooMany": "Terlalu banyak percobaan. Coba lagi nanti.",
    "auth.invalidReset": "Tautan atur ulang tidak valid atau sudah kedaluwarsa.",
    "auth.genericError": "Terjadi kesalahan. Coba lagi.",
    "auth.account": "Akun Saya",
    "auth.profile": "Profil",
    "auth.addresses": "Alamat",
    "auth.addAddress": "Tambah Alamat",
    "auth.setDefault": "Jadikan Utama",
    "auth.defaultBadge": "Utama",
    "auth.label": "Label",
    "auth.recipient": "Nama Penerima",
    "auth.phone": "Telepon",
    "auth.addressLine1": "Alamat Baris 1",
    "auth.addressLine2": "Alamat Baris 2 (opsional)",
    "auth.city": "Kota",
    "auth.province": "Provinsi",
    "auth.postalCode": "Kode Pos",
    "auth.country": "Kode Negara",
    "auth.localeLabel": "Bahasa Pilihan",
    "auth.profileSaved": "Profil diperbarui.",
    "auth.addressSaved": "Alamat disimpan.",
    "auth.addressDeleted": "Alamat dihapus.",
    "auth.loginRequired": "Silakan masuk untuk melihat akun Anda.",
    "auth.noAddresses": "Belum ada alamat tersimpan.",
    "auth.memberSince": "Anggota sejak",
    "cart.title": "Keranjang Belanja",
    "cart.empty": "Keranjang Anda kosong",
    "cart.emptyHint": "Jelajahi departemen kami dan tambahkan produk favorit Anda.",
    "cart.emptyCta": "Lanjut Belanja",
    "cart.subtotal": "Subtotal",
    "cart.remove": "Hapus",
    "cart.checkout": "Lanjut ke Checkout",
    "cart.checkoutUnavailable": "Pembelian online belum tersedia",
    "cart.checkoutUnavailableBody": "Anda dapat menambahkan produk ke keranjang dan meninjau jumlahnya. Checkout online belum tersedia.",
    "cart.shippingNote": "Ongkir akan dikonfirmasi admin kami melalui Telegram.",
    "cart.confirm": "Konfirmasi",
    "cart.confirmNote": "Ini mengirim permintaan keranjang ke chat Telegram toko kami. Tekan Kirim di Telegram untuk mengirimkannya. Ini bukan pesanan final.",
    "cart.confirmUnavailable": "Permintaan keranjang melalui Telegram belum tersedia. Silakan coba lagi nanti.",
    "cart.confirmFailed": "Status permintaan Telegram belum dapat dipastikan. Muat ulang keranjang lalu coba lagi.",
    "cart.confirmCartChanged": "Barang ini sudah tidak ada di keranjang server. Keranjang diperbarui; tambahkan lagi jika masih ingin memesan.",
    "cart.confirmRateLimited": "Terlalu banyak percobaan. Tunggu sebentar sebelum mencoba lagi.",
    "cart.added": "Ditambahkan ke keranjang",
    "cart.exceedsStock": "Pre-order · estimasi 2–3 minggu",
    "cart.demoQuantityLimit": "Maksimal {count} item per produk.",
    "cart.quantityLimit": "Maksimal {count} item per produk.",
    "cart.sizeNoLongerAvailable": "Ukuran ini tidak tersedia untuk pesanan baru. Item yang sudah ada di keranjang tetap bisa dikirim.",
    "cart.mergeAdjusted": "Keranjang tamu berhasil digabungkan.",
    "cart.mergeFailed": "Keranjang tamu belum dapat digabung. Keranjang tetap tersimpan; coba lagi di sini.",
    "cart.mergePending": "Keranjang sedang digabungkan. Tunggu sebelum mengubah item.",
    "wishlist.title": "Wishlist Saya",
    "wishlist.empty": "Wishlist Anda kosong",
    "wishlist.emptyHint": "Sentuh ikon hati pada produk untuk menyimpannya.",
    "wishlist.added": "Ditambahkan ke wishlist",
    "wishlist.removed": "Dihapus dari wishlist",
    "wishlist.loginRequired": "Masuk untuk menyimpan produk ke wishlist.",
    "wishlist.saveAfterLoginFailed": "Anda berhasil masuk, tetapi produk belum tersimpan. Silakan coba lagi.",
    "checkout.title": "Checkout",
    "checkout.contact": "Kontak",
    "checkout.email": "Email",
    "checkout.shippingAddress": "Alamat Pengiriman",
    "checkout.savedAddresses": "Alamat tersimpan",
    "checkout.newAddress": "Gunakan alamat baru",
    "checkout.shippingMethod": "Metode Pengiriman",
    "checkout.paymentMethod": "Metode Pembayaran",
    "checkout.orderSummary": "Ringkasan Pesanan",
    "checkout.subtotal": "Subtotal",
    "checkout.shipping": "Ongkir",
    "checkout.free": "Gratis",
    "checkout.total": "Total",
    "checkout.placeOrder": "Buat Pesanan",
    "checkout.placing": "Membuat pesanan…",
    "checkout.empty": "Keranjang Anda kosong",
    "checkout.emptyCta": "Kembali ke Keranjang",
    "checkout.etaDays": "{days} hari kerja",
    "checkout.stockError": "Sebagian produk tidak tersedia. Silakan periksa keranjang Anda.",
    "checkout.failed": "Tidak dapat membuat pesanan. Silakan coba lagi.",
    "checkout.disabledTitle": "Pembelian online belum tersedia",
    "checkout.disabledBody": "Storefront sudah aktif, tetapi checkout ditutup sementara sampai metode pembayaran dikonfigurasi. Tidak ada pesanan atau pembayaran yang dibuat.",
    "checkout.disabledCta": "Kembali ke katalog",
    "pdp.checkoutUnavailable": "Segera tersedia",
    "paymentPending.title": "Pembayaran sedang dikonfirmasi",
    "paymentPending.body": "Pesanan Anda ditahan sementara kami menunggu konfirmasi dari penyedia pembayaran. Status akan diperiksa otomatis.",
    "paymentPending.failedTitle": "Pembayaran belum selesai",
    "paymentPending.failedBody": "Pembayaran berhasil belum tercatat. Anda dapat kembali berbelanja dan mencoba lagi.",
    "paymentPending.invalidTitle": "Status pesanan tidak tersedia",
    "paymentPending.invalidBody": "Tautan status pembayaran ini tidak valid atau sudah kedaluwarsa.",
    "confirm.title": "Pesanan dikonfirmasi",
    "confirm.thanks": "Terima kasih! Pesanan Anda dikonfirmasi.",
    "confirm.orderNumber": "Nomor pesanan",
    "confirm.totalPaid": "Total dibayar",
    "confirm.emailNote": "Konfirmasi dicatat untuk {email} (email mock dalam pengembangan).",
    "confirm.saveLink": "Simpan halaman ini untuk melihat status pesanan Anda.",
    "confirm.continue": "Lanjut Belanja",
    "confirm.viewOrders": "Lihat Pesanan Saya",
    "orders.title": "Pesanan Saya",
    "orders.empty": "Belum ada pesanan",
    "orders.emptyHint": "Pesanan Anda yang selesai akan muncul di sini.",
    "orders.items": "{count} produk",
    "orders.detailTitle": "Pesanan",
    "orders.paymentState": "Pembayaran",
    "orders.orderStatus": "Status",
    "orders.shippingAddress": "Alamat Pengiriman",
    "orders.shippingMethod": "Metode Pengiriman",
    "orders.subtotal": "Subtotal",
    "orders.shipping": "Ongkir",
    "orders.total": "Total",
    "orders.backToOrders": "Kembali ke pesanan",
    "orders.state.pending_payment": "Menunggu pembayaran",
    "orders.state.paid": "Pre-order diproses",
    "orders.state.cancelled": "Dibatalkan",
    "orders.state.processing": "Diproses",
    "orders.state.shipped": "Dikirim",
    "orders.state.delivered": "Diterima",
    "orders.pay.unpaid": "Belum dibayar",
    "orders.pay.paid": "Dibayar",
    "orders.pay.failed": "Gagal",
    "orders.pay.cancelled": "Dibatalkan",
    "orders.pay.expired": "Kedaluwarsa",
    "orders.pay.refunded": "Dikembalikan",
    "orders.pay.review": "Sedang ditinjau",
    "orders.pay.reconciliation_required": "Perlu ditinjau",
    "paymentPending.reviewTitle": "Pembayaran perlu ditinjau",
    "paymentPending.reviewBody": "Penyedia pembayaran melaporkan transaksi yang memerlukan rekonsiliasi manual. Pesanan akan diperbarui setelah verifikasi.",
    "orders.state.payment_review": "Peninjauan pembayaran",
    "orders.state.supplier_shipping": "Dikirim menuju admin toko",
    "orders.state.received_by_admin": "Diterima admin toko",
    "orders.state.customer_shipping": "Dikirim ke Anda",
    "orders.timeline": "Progress pesanan",
    "orders.expectedBy": "Perkiraan tiba",
    "seller.portal": "Portal Seller",
    "seller.backToStore": "Lihat Toko",
    "seller.forbidden": "Area ini khusus akun seller.",
    "seller.nav.dashboard": "Dasbor",
    "seller.nav.products": "PRODUK",
    "seller.nav.productsList": "Produk",
    "seller.nav.inventory": "Inventaris",
    "seller.nav.orders": "PESANAN",
    "seller.nav.ordersList": "Pesanan",
    "seller.nav.account": "AKUN",
    "seller.nav.profile": "Profil Seller",
    "seller.dashboard.title": "Dasbor",
    "seller.dashboard.activeProducts": "Produk aktif",
    "seller.dashboard.lowStock": "Varian stok menipis",
    "seller.dashboard.outOfStock": "Stok habis",
    "seller.dashboard.needsAction": "Item perlu tindakan",
    "seller.dashboard.salesTotal": "Total penjualan (item pesanan)",
    "seller.dashboard.salesOrders": "Pesanan berbayar",
    "seller.dashboard.salesNote": "Total item pesanan, bukan saldo yang dapat ditarik.",
    "seller.dashboard.recentOrders": "Pesanan terbaru",
    "seller.dashboard.viewAll": "Lihat semua",
    "seller.dashboard.paymentReview": "Pembayaran",
    "seller.dashboard.openInquiries": "Inquiry terbuka",
    "seller.dashboard.preordersInProgress": "Pre-order berjalan",
    "seller.dashboard.ordersByStatus": "Status workflow",
    "seller.dashboard.order": "Order",
    "seller.dashboard.date": "Tanggal",
    "seller.dashboard.status": "Status",
    "seller.dashboard.payment": "Pembayaran",
    "seller.dashboard.total": "Total",
    "seller.dashboard.noRecentOrders": "Belum ada order terbaru.",
    "seller.dashboard.errorTitle": "Dashboard gagal dimuat",
    "seller.dashboard.errorDescription": "Data dashboard tidak dapat dimuat. Katalog dan order Anda tetap aman.",
    "seller.dashboard.retry": "Coba lagi",
    "seller.dashboard.status.inquiry": "Inquiry",
    "seller.dashboard.status.payment": "Pembayaran",
    "seller.dashboard.status.pending_payment": "Menunggu pembayaran",
    "seller.dashboard.status.payment_review": "Pembayaran perlu ditinjau",
    "seller.dashboard.status.paid": "Sudah dibayar",
    "seller.dashboard.status.supplier_shipping": "Supplier mengirim",
    "seller.dashboard.status.received_by_admin": "Diterima admin",
    "seller.dashboard.status.customer_shipping": "Dikirim ke customer",
    "seller.dashboard.status.delivered": "Selesai",
    "seller.products.title": "Produk",
    "seller.products.new": "Produk Baru",
    "seller.products.searchPlaceholder": "Cari produk Anda…",
    "seller.products.status": "Status",
    "seller.products.allStatuses": "Semua status",
    "seller.products.inventory": "Inventaris",
    "seller.products.allInventory": "Semua inventaris",
    "seller.products.empty": "Tidak ada produk.",
    "seller.products.product": "Produk",
    "seller.products.price": "Harga",
    "seller.products.variants": "Varian",
    "seller.products.stock": "Stok",
    "seller.products.edit": "Ubah",
    "seller.products.prev": "Sebelumnya",
    "seller.products.next": "Berikutnya",
    "seller.stock.in_stock": "Tersedia",
    "seller.stock.low_stock": "Stok Menipis",
    "seller.stock.out_of_stock": "Stok Habis",
    "seller.status.active": "Aktif",
    "seller.status.draft": "Draf",
    "seller.status.inactive": "Nonaktif",
    "seller.editor.backToProducts": "Kembali ke produk",
    "seller.editor.createTitle": "Produk Baru",
    "seller.editor.editTitle": "Ubah Produk",
    "seller.editor.basics": "Dasar",
    "seller.editor.category": "Kategori",
    "seller.editor.type": "Tipe produk",
    "seller.editor.brand": "Merek",
    "seller.editor.basePrice": "Harga dasar",
    "seller.editor.compareAt": "Harga pembanding",
    "seller.editor.status": "Status",
    "seller.editor.imageUrl": "URL Gambar",
    "seller.editor.mediaHint": "Upload gambar produk langsung di sini; gambar disimpan di pustaka media CMS lokal.",
    "seller.editor.translations": "Terjemahan",
    "seller.editor.name": "Nama",
    "seller.editor.shortDesc": "Deskripsi singkat",
    "seller.editor.description": "Deskripsi",
    "seller.editor.variants": "Varian",
    "seller.editor.addVariant": "Tambah varian",
    "seller.editor.optionsHint": "Opsi sebagai pasangan key=value, dipisah koma (mis. color=Black, size=M atau volume=50 ml).",
    "seller.editor.sku": "SKU",
    "seller.editor.options": "Opsi",
    "seller.editor.stock": "Stok",
    "seller.editor.priceOverride": "Harga khusus",
    "seller.editor.saleOverride": "Harga promo",
    "seller.editor.active": "Aktif",
    "seller.editor.save": "Simpan",
    "seller.editor.saving": "Menyimpan…",
    "seller.editor.saved": "Produk tersimpan.",
    "seller.editor.failed": "Gagal menyimpan. Coba lagi.",
    "seller.editor.skuExists": "SKU sudah digunakan. SKU harus unik secara global.",
    "seller.editor.reservationFloor": "Stok tidak boleh di bawah {count} — ada reservasi checkout aktif.",
    "seller.editor.archive": "Arsipkan",
    "seller.editor.archived": "Produk diarsipkan.",
    "seller.inventory.title": "Inventaris",
    "seller.inventory.hint": "Stok fisik saja. Reservasi checkout aktif dikendalikan sistem dan tidak dapat diubah.",
    "seller.inventory.physical": "Fisik",
    "seller.inventory.reserved": "Direservasi",
    "seller.inventory.available": "Tersedia",
    "seller.inventory.save": "Simpan",
    "seller.inventory.updated": "Stok diperbarui.",
    "seller.inventory.failed": "Gagal memperbarui stok.",
    "seller.inventory.floorError": "Tidak boleh di bawah {count} — ada reservasi checkout aktif.",
    "seller.orders.title": "Pesanan",
    "seller.orders.allFulfillments": "Semua status fulfillment",
    "seller.orders.order": "Pesanan",
    "seller.orders.date": "Tanggal",
    "seller.orders.recipient": "Penerima",
    "seller.orders.items": "Item",
    "seller.orders.payment": "Pembayaran",
    "seller.orders.fulfillment": "Fulfillment",
    "seller.orders.subtotal": "Subtotal Anda",
    "seller.orders.empty": "Belum ada pesanan.",
    "seller.fulfillment.pending": "Pending",
    "seller.fulfillment.processing": "Diproses",
    "seller.fulfillment.shipped": "Dikirim",
    "seller.fulfillment.delivered": "Diterima",
    "seller.fulfillment.cancelled": "Dibatalkan",
    "seller.orderDetail.items": "Item Anda",
    "seller.orderDetail.actions": "Fulfillment",
    "seller.orderDetail.blockedUnpaid": "Pembayaran belum terkonfirmasi — fulfillment diblokir sampai pesanan dibayar.",
    "seller.orderDetail.mark_processing": "Mulai diproses",
    "seller.orderDetail.mark_shipped": "Tandai dikirim",
    "seller.orderDetail.mark_delivered": "Tandai diterima",
    "seller.orderDetail.noActions": "Tidak ada aksi lagi.",
    "seller.orderDetail.carrier": "Kurir",
    "seller.orderDetail.trackingNumber": "Nomor resi",
    "seller.orderDetail.customer": "Penerima & pengiriman",
    "seller.orderDetail.updated": "Fulfillment diperbarui.",
    "seller.orderDetail.invalidTransition": "Perubahan status tidak diizinkan.",
    "seller.orderDetail.failed": "Aksi gagal. Coba lagi.",
    "seller.profile.title": "Profil Seller",
    "seller.profile.storeName": "Nama toko",
    "seller.profile.phone": "Telepon kontak",
    "seller.profile.description": "Deskripsi toko",
    "seller.profile.email": "Email akun",
    "seller.profile.slug": "Slug toko",
    "seller.profile.memberSince": "Bergabung",
    "seller.profile.save": "Simpan profil",
    "seller.profile.saved": "Profil tersimpan.",
    "page.title.cart": "Keranjang",
    "page.title.wishlist": "Wishlist",
    "page.title.account": "Akun",
    "page.title.checkout": "Checkout",
    "page.title.seller": "Penjual",
    "page.title.admin": "Admin",
  },
  uz: {
    "announcement.text": "",
    "brand.name": "MUSLIMAH CANTIK",
    "brand.tagline": "Muslimona moda va halol teri parvarishi",
    "nav.home": "Bosh sahifa",
    "nav.womenMuslimah": "Muslima ayollar kiyimlari",
    "nav.apparel": "Kiyimlar",
    "nav.skincare": "Teri parvarishi",
    "header.searchPlaceholder": "Mahsulot qidirish",
    "header.account": "Hisob",
    "header.wishlist": "Sevimlilar",
    "header.cart": "Savat",
    "header.openMenu": "Menyuni ochish",
    "header.closeMenu": "Yopish",
    "header.language": "Til",
    "footer.shop": "Xarid",
    "footer.help": "Yordam",
    "footer.about": "Haqida",
    "footer.rights": "© 2026 MUSLIMAH CANTIK. Barcha huquqlar himoyalangan.",
    "footer.description": "Muslimona moda va tropik halol teri parvarishi uchun zamonaviy bozor.",
    "footer.link.newArrivals": "Yangi kelganlar",
    "footer.link.bestSellers": "Eng ko'p sotilgan",
    "footer.link.contact": "Biz bilan bog'laning",
    "footer.link.shipping": "Yetkazib berish",
    "footer.link.returns": "Qaytarish va almashtirish",
    "footer.link.faq": "Savol-javoblar",
    "footer.link.aboutUs": "Biz haqimizda",
    "footer.link.stores": "Do'konlarimiz",
    "footer.link.privacy": "Maxfiylik siyosati",
    "footer.link.terms": "Foydalanish shartlari",
    "common.loading": "Yuklanmoqda…",
    "common.error": "Xatolik yuz berdi",
    "common.retry": "Qayta urinish",
    "common.empty": "Bu yerda hali hech narsa yo'q",
    "common.comingSoon": "Bu bo'lim tez orada ochiladi.",
    "common.close": "Yopish",
    "common.edit": "Tahrirlash",
    "common.delete": "O'chirish",
    "common.cancel": "Bekor qilish",
    "common.save": "Saqlash",
    "common.back": "Orqaga",
    "common.submit": "Yuborish",
    "validation.required": "Ushbu maydon to'ldirilishi shart",
    "validation.email": "To'g'ri elektron pochta manzilini kiriting",
    "validation.minLength": "Juda qisqa",
    "validation.maxLength": "Juda uzun",
    "errors.generic": "Kutilmagan xatolik yuz berdi.",
    "errors.network": "Tarmoq xatosi. Ulanishni tekshiring.",
    "errors.notFound": "Sahifa topilmadi.",
    "page.home.heroTitle": "Muslimona tanlov — Kuz-Qish 2026",
    "page.home.heroSubtitle": "Muslima ayollar kiyimlari, kundalik kiyimlar va tropik halol teri parvarishi bo'yicha yangi kelganlar.",
    "page.home.placeholderNote": "Do'kon bo'limlari tez orada ishga tushadi.",
    "nav.newArrivals": "Yangi kelganlar",
    "nav.bestSellers": "Eng ko'p sotilgan",
    "nav.sale": "Chegirmalar",
    "nav.uniqloProducts": "UNIQLO mahsulotlari",
    "search.browseCategories": "Kategoriyalarni ko'rish",
    "home.shopByCategory": "Kategoriya bo'yicha xarid",
    "home.shopByDepartment": "Bo'lim bo'yicha xarid",
    "home.newArrivals": "Yangi kelganlar",
    "home.bestSellers": "Eng ko'p sotilgan",
    "home.viewAll": "Barchasini ko'rish",
    "home.shopNow": "Hozir xarid qiling",
    "home.allDepartments": "Barcha bo'limlar",
    "home.deptCta": "Kashf eting",
    "plp.results": "Natijalar: {count} ta mahsulot",
    "plp.sortBy": "Saralash",
    "plp.filter": "Filtr",
    "product.new": "YANGI",
    "product.sale": "CHEGIRMA",
    "product.catalog": "KATALOG",
    "product.catalogLabel": "Pre-order",
    "preorder.label": "Pre-order · taxminiy 2–3 hafta",
    "preorder.sizeAvailability": "O‘lcham buyurtma vaqtida mavjud bo‘lgan zaxiraga bog‘liq",
    "preorder.sizeAvailabilityShort": "O‘lcham mavjudligi buyurtma paytidagi zaxiraga bog‘liq",
    "product.wishlist": "Sevimlilarga qo'shish",
    "footer.account": "Hisob",
    "footer.link.myAccount": "Mening hisobim",
    "footer.link.orders": "Buyurtmalar",
    "footer.promo": "",
    "editorial.title": "Hikoyalar va qo'llanmalar",
    "editorial.cta": "Batafsil",
    "page.title.search": "Qidiruv",
    "page.title.shop": "Do'kon",
    "plp.filters": "Filtrlar",
    "plp.price": "Narx",
    "plp.minPrice": "Min",
    "plp.maxPrice": "Maks",
    "plp.apply": "Qo'llash",
    "plp.color": "Rang",
    "plp.size": "O'lcham",
    "plp.volume": "Hajm",
    "plp.motif": "Naqsh",
    "plp.format": "Format",
    "plp.availability": "Buyurtma rejimi",
    "plp.inStock": "Pre-order",
    "plp.clearFilters": "Barchasini tozalash",
    "plp.noResults": "Filtrlarga mos mahsulot topilmadi.",
    "plp.noProducts": "To‘plam tayyorlanmoqda.",
    "plp.noProductsHint": "Yuqoridagi toifalarni ko‘ring. To‘plam tayyor bo‘lgach mahsulotlar shu yerda paydo bo‘ladi.",
    "plp.noResultsHint": "Filtrni olib tashlang yoki boshqa parametrni tanlang.",
    "plp.pageOf": "Sahifa {page} / {pages}",
    "plp.prev": "Oldingi",
    "plp.next": "Keyingi",
    "sort.featured": "Tanlangan",
    "sort.newest": "Eng yangi",
    "sort.priceAsc": "Narx: arzondan",
    "sort.priceDesc": "Narx: qimmatdan",
    "product.outOfStock": "Pre-order orqali mavjud",
    "product.lowStock": "Pre-order orqali mavjud",
    "search.resultsFor": "\"{q}\" bo'yicha natijalar",
    "search.noResults": "Hech narsa topilmadi. Boshqa so'z bilan urinib ko'ring.",
    "search.resultsCount": "{count} ta mahsulot",
    "page.title.product": "Mahsulot",
    "pdp.quantity": "Miqdor",
    "pdp.addToCart": "Savatga qo'shish",
    "pdp.addToWishlist": "Sevimlilarga qo'shish",
    "pdp.catalogNotice": "Pre-order · taxminiy 2–3 hafta",
    "pdp.sizeGuide": "O'lcham qo'llanmasi",
    "pdp.sizeGuideNote": "O'lchovlar sm da. Ikki o'lcham orasida bo'lsangiz, kattaroqni tanlang.",
    "pdp.chest": "Ko'krak",
    "pdp.length": "Uzunlik",
    "options.color": "Rang",
    "options.size": "O'lcham",
    "options.material": "Mato",
    "options.volume": "Hajm",
    "options.motif": "Naqsh",
    "options.format": "Format",
    "product.inStock": "Pre-order · taxminiy 2–3 hafta",
    "pdp.onlyLeft": "Pre-order · taxminiy 2–3 hafta",
    "pdp.description": "Tavsif",
    "pdp.features": "Xususiyatlar",
    "pdp.materialCare": "Mato va parvarish",
    "pdp.details": "Mahsulot tafsilotlari",
    "pdp.ingredients": "Tarkibi",
    "pdp.benefits": "Foydalari",
    "pdp.directions": "Qo'llash usuli",
    "pdp.fragrance": "Aroma",
    "pdp.fragranceFamily": "Aroma oilasi",
    "pdp.notes": "Notalar",
    "pdp.usage": "Qo'llash usuli",
    "pdp.alcoholFree": "Spirtsiz formula",
    "pdp.motif": "Naqsh",
    "pdp.halalCertified": "Halol sertifikatlangan",
    "pdp.skinType": "Teri turi",
    "pdp.sku": "SKU",
    "pdp.selectionReady": "Variant tanlandi — savat keyingi bosqichda ishga tushadi.",
    "auth.login": "Kirish",
    "auth.register": "Ro'yxatdan o'tish",
    "auth.email": "Email",
    "auth.password": "Parol",
    "auth.firstName": "Ism",
    "auth.lastName": "Familiya",
    "auth.forgot": "Parolni unutdingizmi?",
    "auth.noAccount": "Hisobingiz yo'qmi?",
    "auth.haveAccount": "Hisobingiz bormi?",
    "auth.logout": "Chiqish",
    "auth.forgotTitle": "Parolni tiklash",
    "auth.forgotText": "Hisob emailingizni kiriting — tiklash havolasini yuboramiz.",
    "auth.forgotSent": "Agar email ro'yxatdan o'tgan bo'lsa, tiklash havolasi yuborildi.",
    "auth.sendLink": "Havolani yuborish",
    "auth.resetTitle": "Yangi parol tanlang",
    "auth.newPassword": "Yangi parol",
    "auth.resetCta": "Parolni tiklash",
    "auth.resetDone": "Parol yangilandi. Endi kirishingiz mumkin.",
    "auth.backToLogin": "Kirishga qaytish",
    "auth.invalidCredentials": "Email yoki parol noto'g'ri.",
    "auth.adminOnly": "Bu hisob Admin Console orqali kirishi kerak.",
    "auth.customerOnly": "Bu hisob mijozlar do‘koniga kira olmaydi.",
    "auth.sessionExpired": "Seansingiz muddati tugadi. Iltimos, qayta kiring.",
    "auth.emailExists": "Bu email bilan hisob allaqachon mavjud.",
    "auth.tooMany": "Juda ko'p urinish. Keyinroq urinib ko'ring.",
    "auth.invalidReset": "Tiklash havolasi yaroqsiz yoki muddati o'tgan.",
    "auth.genericError": "Xatolik yuz berdi. Qayta urinib ko'ring.",
    "auth.account": "Mening hisobim",
    "auth.profile": "Profil",
    "auth.addresses": "Manzillar",
    "auth.addAddress": "Manzil qo'shish",
    "auth.setDefault": "Asosiy qilish",
    "auth.defaultBadge": "Asosiy",
    "auth.label": "Yorliq",
    "auth.recipient": "Qabul qiluvchi",
    "auth.phone": "Telefon",
    "auth.addressLine1": "Manzil 1-qator",
    "auth.addressLine2": "Manzil 2-qator (ixtiyoriy)",
    "auth.city": "Shahar",
    "auth.province": "Viloyat",
    "auth.postalCode": "Pochta indeksi",
    "auth.country": "Mamlakat kodi",
    "auth.localeLabel": "Afzal til",
    "auth.profileSaved": "Profil yangilandi.",
    "auth.addressSaved": "Manzil saqlandi.",
    "auth.addressDeleted": "Manzil o'chirildi.",
    "auth.loginRequired": "Hisobingizni ko'rish uchun kiring.",
    "auth.noAddresses": "Saqlangan manzillar yo'q.",
    "auth.memberSince": "A'zo bo'lgan sana",
    "cart.title": "Savat",
    "cart.empty": "Savatingiz bo'sh",
    "cart.emptyHint": "Bo'limlarimizni ko'rib chiqing va yoqqan mahsulotni qo'shing.",
    "cart.emptyCta": "Xaridni davom eting",
    "cart.subtotal": "Oraliq jami",
    "cart.remove": "O'chirish",
    "cart.checkout": "Buyurtmani rasmiylashtirish",
    "cart.checkoutUnavailable": "Onlayn xarid hali mavjud emas",
    "cart.checkoutUnavailableBody": "Mahsulotlarni savatga qo‘shib, miqdorini ko‘rib chiqishingiz mumkin. Onlayn rasmiylashtirish hozircha mavjud emas.",
    "cart.shippingNote": "Yetkazib berish narxini adminimiz Telegram orqali tasdiqlaydi.",
    "cart.confirm": "Tasdiqlash",
    "cart.confirmNote": "Bu savat so‘rovini do‘konimizning Telegram chatiga yuboradi. Yuborish uchun Telegram’da Jo‘natish tugmasini bosing. Bu yakuniy buyurtma emas.",
    "cart.confirmUnavailable": "Telegram orqali savat so‘rovi hozircha mavjud emas. Keyinroq qayta urinib ko‘ring.",
    "cart.confirmFailed": "Telegram so‘rovi tayyorlangan-tayyorlanmagani aniqlanmadi. Savatni yangilab, qayta urinib ko‘ring.",
    "cart.confirmCartChanged": "Bu mahsulotlar server savatida yo‘q. Savat yangilandi; buyurtma bermoqchi bo‘lsangiz, mahsulotlarni qayta qo‘shing.",
    "cart.confirmRateLimited": "Urinishlar soni juda ko‘p. Qayta urinishdan oldin biroz kuting.",
    "cart.added": "Savatga qo'shildi",
    "cart.exceedsStock": "Pre-order · taxminiy 2–3 hafta",
    "cart.demoQuantityLimit": "Har bir mahsulot uchun maksimal {count} ta.",
    "cart.quantityLimit": "Har bir mahsulot uchun maksimal {count} ta.",
    "cart.sizeNoLongerAvailable": "Bu o‘lcham yangi buyurtmalar uchun mavjud emas. Savatingizdagi mahsulotni yuborishingiz mumkin.",
    "cart.mergeAdjusted": "Mehmon savati birlashtirildi.",
    "cart.mergeFailed": "Mehmon savatini birlashtirib bo‘lmadi. Savat saqlandi; shu yerda qayta urinib ko‘ring.",
    "cart.mergePending": "Savat birlashtirilmoqda. Iltimos, itemlarni o‘zgartirishdan oldin kuting.",
    "wishlist.title": "Sevimlilarim",
    "wishlist.empty": "Sevimlilar ro'yxati bo'sh",
    "wishlist.emptyHint": "Mahsulotdagi yurak belgisini bosing.",
    "wishlist.added": "Sevimlilarga qo'shildi",
    "wishlist.removed": "Sevimlilardan o'chirildi",
    "wishlist.loginRequired": "Sevimlilarga saqlash uchun kiring.",
    "wishlist.saveAfterLoginFailed": "Kirdingiz, ammo mahsulot saqlanmadi. Qayta urinib ko‘ring.",
    "checkout.title": "Checkout",
    "checkout.contact": "Kontakt",
    "checkout.email": "Email",
    "checkout.shippingAddress": "Yetkazish manzili",
    "checkout.savedAddresses": "Saqlangan manzillar",
    "checkout.newAddress": "Yangi manzil ishlatish",
    "checkout.shippingMethod": "Yetkazish usuli",
    "checkout.paymentMethod": "To'lov usuli",
    "checkout.orderSummary": "Buyurtma xulosasi",
    "checkout.subtotal": "Oraliq jami",
    "checkout.shipping": "Yetkazish",
    "checkout.free": "Bepul",
    "checkout.total": "Jami",
    "checkout.placeOrder": "Buyurtma berish",
    "checkout.placing": "Buyurtma yaratilmoqda…",
    "checkout.empty": "Savatingiz bo'sh",
    "checkout.emptyCta": "Savatga qaytish",
    "checkout.etaDays": "{days} ish kuni",
    "checkout.stockError": "Ba'zi mahsulotlar mavjud emas. Savatingizni tekshiring.",
    "checkout.failed": "Buyurtma yaratib bo'lmadi. Qayta urinib ko'ring.",
    "checkout.disabledTitle": "Onlayn xarid hali mavjud emas",
    "checkout.disabledBody": "Do'kon ishlamoqda, ammo to'lov usuli sozlanguncha checkout yopiq. Hech qanday buyurtma yoki to'lov yaratilmaydi.",
    "checkout.disabledCta": "Katalogga qaytish",
    "pdp.checkoutUnavailable": "Tez orada",
    "paymentPending.title": "To'lov tasdiqlanmoqda",
    "paymentPending.body": "To'lov provayderidan tasdiq kutayotganimizda buyurtmangiz band qilindi. Holat avtomatik tekshiriladi.",
    "paymentPending.failedTitle": "To'lov yakunlanmadi",
    "paymentPending.failedBody": "Muvaffaqiyatli to'lov qayd etilmadi. Do'konga qaytib, qayta urinib ko'rishingiz mumkin.",
    "paymentPending.invalidTitle": "Buyurtma holati mavjud emas",
    "paymentPending.invalidBody": "To'lov holati havolasi yaroqsiz yoki muddati o'tgan.",
    "confirm.title": "Buyurtma tasdiqlandi",
    "confirm.thanks": "Rahmat! Buyurtmangiz tasdiqlandi.",
    "confirm.orderNumber": "Buyurtma raqami",
    "confirm.totalPaid": "To'langan summa",
    "confirm.emailNote": "{email} uchun tasdiq qayd etildi (ishlab chiqishda mock email).",
    "confirm.saveLink": "Buyurtma holatini ko'rish uchun bu sahifani saqlab qo'ying.",
    "confirm.continue": "Xaridni davom eting",
    "confirm.viewOrders": "Buyurtmalarim",
    "orders.title": "Buyurtmalarim",
    "orders.empty": "Hali buyurtmalar yo'q",
    "orders.emptyHint": "Yakunlangan buyurtmalaringiz shu yerda ko'rinadi.",
    "orders.items": "{count} mahsulot",
    "orders.detailTitle": "Buyurtma",
    "orders.paymentState": "To'lov",
    "orders.orderStatus": "Holat",
    "orders.shippingAddress": "Yetkazish manzili",
    "orders.shippingMethod": "Yetkazish usuli",
    "orders.subtotal": "Oraliq jami",
    "orders.shipping": "Yetkazish",
    "orders.total": "Jami",
    "orders.backToOrders": "Buyurtmalarga qaytish",
    "orders.state.pending_payment": "To'lov kutilmoqda",
    "orders.state.paid": "Pre-order jarayonda",
    "orders.state.cancelled": "Bekor qilingan",
    "orders.state.processing": "Qayta ishlanmoqda",
    "orders.state.shipped": "Yuborildi",
    "orders.state.delivered": "Yetkazildi",
    "orders.pay.unpaid": "To'lanmagan",
    "orders.pay.paid": "To'langan",
    "orders.pay.failed": "Xato",
    "orders.pay.cancelled": "Bekor qilingan",
    "orders.pay.expired": "Muddati o'tgan",
    "orders.pay.refunded": "Qaytarilgan",
    "orders.pay.review": "Ko'rib chiqilmoqda",
    "orders.pay.reconciliation_required": "Tekshiruv kerak",
    "paymentPending.reviewTitle": "To'lov tekshiruvni talab qiladi",
    "paymentPending.reviewBody": "To'lov provayderi qo'lda tekshirilishi kerak bo'lgan tranzaksiyani qaytardi. Tasdiqlangach buyurtma yangilanadi.",
    "orders.state.payment_review": "To'lov ko'rib chiqilmoqda",
    "orders.state.supplier_shipping": "Do'kon adminiga yuborildi",
    "orders.state.received_by_admin": "Do'kon admini qabul qildi",
    "orders.state.customer_shipping": "Sizga yuborildi",
    "orders.timeline": "Buyurtma jarayoni",
    "orders.expectedBy": "Kutilayotgan sana",
    "seller.portal": "Seller portali",
    "seller.backToStore": "Do'konni ko'rish",
    "seller.forbidden": "Bu bo'lim faqat seller hisoblari uchun.",
    "seller.nav.dashboard": "Boshqaruv",
    "seller.nav.products": "MAHSULOTLAR",
    "seller.nav.productsList": "Mahsulotlar",
    "seller.nav.inventory": "Ombor",
    "seller.nav.orders": "BUYURTMALAR",
    "seller.nav.ordersList": "Buyurtmalar",
    "seller.nav.account": "HISOB",
    "seller.nav.profile": "Seller profili",
    "seller.dashboard.title": "Boshqaruv paneli",
    "seller.dashboard.activeProducts": "Faol mahsulotlar",
    "seller.dashboard.lowStock": "Kam qolgan variantlar",
    "seller.dashboard.outOfStock": "Tugagan",
    "seller.dashboard.needsAction": "Amal talab qiladigan elementlar",
    "seller.dashboard.salesTotal": "Sotuv summasi (buyurtma elementlari)",
    "seller.dashboard.salesOrders": "To'langan buyurtmalar",
    "seller.dashboard.salesNote": "Buyurtma elementlari summasi — yechib olish balansi emas.",
    "seller.dashboard.recentOrders": "So'nggi buyurtmalar",
    "seller.dashboard.viewAll": "Barchasini ko'rish",
    "seller.dashboard.paymentReview": "To'lovlar",
    "seller.dashboard.openInquiries": "Ochiq so'rovlar",
    "seller.dashboard.preordersInProgress": "Jarayondagi oldindan buyurtmalar",
    "seller.dashboard.ordersByStatus": "Workflow holati",
    "seller.dashboard.order": "Buyurtma",
    "seller.dashboard.date": "Sana",
    "seller.dashboard.status": "Holat",
    "seller.dashboard.payment": "To'lov",
    "seller.dashboard.total": "Jami",
    "seller.dashboard.noRecentOrders": "Yaqinda buyurtmalar yo'q.",
    "seller.dashboard.errorTitle": "Boshqaruv paneli yuklanmadi",
    "seller.dashboard.errorDescription": "Dashboard ma'lumotlarini yuklab bo'lmadi. Katalog va buyurtmalaringiz o'zgarmadi.",
    "seller.dashboard.retry": "Qayta urinib ko'rish",
    "seller.dashboard.status.inquiry": "So'rov",
    "seller.dashboard.status.payment": "To'lov",
    "seller.dashboard.status.pending_payment": "To'lov kutilmoqda",
    "seller.dashboard.status.payment_review": "To'lov tekshiruvi",
    "seller.dashboard.status.paid": "To'langan",
    "seller.dashboard.status.supplier_shipping": "Yetkazib beruvchi yubormoqda",
    "seller.dashboard.status.received_by_admin": "Admin qabul qildi",
    "seller.dashboard.status.customer_shipping": "Mijozga yuborilmoqda",
    "seller.dashboard.status.delivered": "Yakunlangan",
    "seller.products.title": "Mahsulotlar",
    "seller.products.new": "Yangi mahsulot",
    "seller.products.searchPlaceholder": "Mahsulotlaringizni qidiring…",
    "seller.products.status": "Holat",
    "seller.products.allStatuses": "Barcha holatlar",
    "seller.products.inventory": "Ombor",
    "seller.products.allInventory": "Butun ombor",
    "seller.products.empty": "Mahsulot topilmadi.",
    "seller.products.product": "Mahsulot",
    "seller.products.price": "Narx",
    "seller.products.variants": "Variantlar",
    "seller.products.stock": "Zaxira",
    "seller.products.edit": "Tahrirlash",
    "seller.products.prev": "Oldingi",
    "seller.products.next": "Keyingi",
    "seller.stock.in_stock": "Mavjud",
    "seller.stock.low_stock": "Kam qolgan",
    "seller.stock.out_of_stock": "Tugagan",
    "seller.status.active": "Faol",
    "seller.status.draft": "Qoralama",
    "seller.status.inactive": "Nofaol",
    "seller.editor.backToProducts": "Mahsulotlarga qaytish",
    "seller.editor.createTitle": "Yangi mahsulot",
    "seller.editor.editTitle": "Mahsulotni tahrirlash",
    "seller.editor.basics": "Asosiy",
    "seller.editor.category": "Kategoriya",
    "seller.editor.type": "Mahsulot turi",
    "seller.editor.brand": "Brend",
    "seller.editor.basePrice": "Asosiy narx",
    "seller.editor.compareAt": "Solishtirish narxi",
    "seller.editor.status": "Holat",
    "seller.editor.imageUrl": "Rasm URL",
    "seller.editor.mediaHint": "Mahsulot rasmlarini shu yerda yuklang; ular mahalliy CMS media kutubxonasida saqlanadi.",
    "seller.editor.translations": "Tarjimalar",
    "seller.editor.name": "Nomi",
    "seller.editor.shortDesc": "Qisqa tavsif",
    "seller.editor.description": "Tavsif",
    "seller.editor.variants": "Variantlar",
    "seller.editor.addVariant": "Variant qo'shish",
    "seller.editor.optionsHint": "Opsiyalar key=value juftliklari, vergul bilan (mas. color=Black, size=M yoki volume=50 ml).",
    "seller.editor.sku": "SKU",
    "seller.editor.options": "Opsiyalar",
    "seller.editor.stock": "Zaxira",
    "seller.editor.priceOverride": "Maxsus narx",
    "seller.editor.saleOverride": "Aksiya narxi",
    "seller.editor.active": "Faol",
    "seller.editor.save": "Saqlash",
    "seller.editor.saving": "Saqlanmoqda…",
    "seller.editor.saved": "Mahsulot saqlandi.",
    "seller.editor.failed": "Saqlab bo'lmadi. Qayta urinib ko'ring.",
    "seller.editor.skuExists": "Bu SKU band. SKU global yagona bo'lishi kerak.",
    "seller.editor.reservationFloor": "Zaxira {count} dan kam bo'lishi mumkin emas — faol checkout reservatsiyalari bor.",
    "seller.editor.archive": "Arxivlash",
    "seller.editor.archived": "Mahsulot arxivlandi.",
    "seller.inventory.title": "Ombor",
    "seller.inventory.hint": "Faqat fizik zaxira. Faol checkout reservatsiyalari tizim tomonidan boshqariladi.",
    "seller.inventory.physical": "Fizik",
    "seller.inventory.reserved": "Band qilingan",
    "seller.inventory.available": "Mavjud",
    "seller.inventory.save": "Saqlash",
    "seller.inventory.updated": "Zaxira yangilandi.",
    "seller.inventory.failed": "Zaxirani yangilab bo'lmadi.",
    "seller.inventory.floorError": "{count} dan kam bo'lishi mumkin emas — faol checkout reservatsiyalari.",
    "seller.orders.title": "Buyurtmalar",
    "seller.orders.allFulfillments": "Barcha fulfillment holatlari",
    "seller.orders.order": "Buyurtma",
    "seller.orders.date": "Sana",
    "seller.orders.recipient": "Qabul qiluvchi",
    "seller.orders.items": "Elementlar",
    "seller.orders.payment": "To'lov",
    "seller.orders.fulfillment": "Fulfillment",
    "seller.orders.subtotal": "Sizning jamingiz",
    "seller.orders.empty": "Hali buyurtmalar yo'q.",
    "seller.fulfillment.pending": "Kutilmoqda",
    "seller.fulfillment.processing": "Qayta ishlanmoqda",
    "seller.fulfillment.shipped": "Yuborildi",
    "seller.fulfillment.delivered": "Yetkazildi",
    "seller.fulfillment.cancelled": "Bekor qilingan",
    "seller.orderDetail.items": "Sizning elementlaringiz",
    "seller.orderDetail.actions": "Fulfillment",
    "seller.orderDetail.blockedUnpaid": "To'lov tasdiqlanmagan — buyurtma to'lanmaguncha fulfillment bloklangan.",
    "seller.orderDetail.mark_processing": "Qayta ishlashni boshlash",
    "seller.orderDetail.mark_shipped": "Yuborildi deb belgilash",
    "seller.orderDetail.mark_delivered": "Yetkazildi deb belgilash",
    "seller.orderDetail.noActions": "Boshqa amal yo'q.",
    "seller.orderDetail.carrier": "Kuryer",
    "seller.orderDetail.trackingNumber": "Kuzatuv raqami",
    "seller.orderDetail.customer": "Qabul qiluvchi va yetkazish",
    "seller.orderDetail.updated": "Fulfillment yangilandi.",
    "seller.orderDetail.invalidTransition": "Bu holat o'zgarishiga ruxsat yo'q.",
    "seller.orderDetail.failed": "Amal bajarilmadi. Qayta urinib ko'ring.",
    "seller.profile.title": "Seller profili",
    "seller.profile.storeName": "Do'kon nomi",
    "seller.profile.phone": "Aloqa telefoni",
    "seller.profile.description": "Do'kon tavsifi",
    "seller.profile.email": "Hisob emaili",
    "seller.profile.slug": "Do'kon slug",
    "seller.profile.memberSince": "A'zo bo'lgan",
    "seller.profile.save": "Profilni saqlash",
    "seller.profile.saved": "Profil saqlandi.",
    "page.title.cart": "Savat",
    "page.title.wishlist": "Sevimlilar",
    "page.title.account": "Hisob",
    "page.title.checkout": "Buyurtmani rasmiylashtirish",
    "page.title.seller": "Sotuvchi",
    "page.title.admin": "Administrator",
  },
  ru: {
    "announcement.text": "",
    "brand.name": "MUSLIMAH CANTIK",
    "brand.tagline": "Мусульманская мода и халяль-уход",
    "nav.home": "Главная",
    "nav.womenMuslimah": "Женская мусульманская одежда",
    "nav.apparel": "Одежда",
    "nav.skincare": "Уход за кожей",
    "header.searchPlaceholder": "Поиск товаров",
    "header.account": "Аккаунт",
    "header.wishlist": "Избранное",
    "header.cart": "Корзина",
    "header.openMenu": "Открыть меню",
    "header.closeMenu": "Закрыть",
    "header.language": "Язык",
    "footer.shop": "Покупки",
    "footer.help": "Помощь",
    "footer.about": "О компании",
    "footer.rights": "© 2026 MUSLIMAH CANTIK. Все права защищены.",
    "footer.description": "Современный маркетплейс мусульманской моды и тропического халяль-ухода за кожей.",
    "footer.link.newArrivals": "Новинки",
    "footer.link.bestSellers": "Бестселлеры",
    "footer.link.contact": "Связаться с нами",
    "footer.link.shipping": "Доставка",
    "footer.link.returns": "Возврат и обмен",
    "footer.link.faq": "Вопросы и ответы",
    "footer.link.aboutUs": "О нас",
    "footer.link.stores": "Наши магазины",
    "footer.link.privacy": "Политика конфиденциальности",
    "footer.link.terms": "Условия использования",
    "common.loading": "Загрузка…",
    "common.error": "Что-то пошло не так",
    "common.retry": "Повторить",
    "common.empty": "Здесь пока пусто",
    "common.comingSoon": "Этот раздел скоро появится.",
    "common.close": "Закрыть",
    "common.edit": "Изменить",
    "common.delete": "Удалить",
    "common.cancel": "Отмена",
    "common.save": "Сохранить",
    "common.back": "Назад",
    "common.submit": "Отправить",
    "validation.required": "Обязательное поле",
    "validation.email": "Введите корректный email",
    "validation.minLength": "Слишком коротко",
    "validation.maxLength": "Слишком длинно",
    "errors.generic": "Произошла непредвиденная ошибка.",
    "errors.network": "Ошибка сети. Проверьте подключение.",
    "errors.notFound": "Страница не найдена.",
    "page.home.heroTitle": "Мусульманская подборка — Осень-Зима 2026",
    "page.home.heroSubtitle": "Новинки: женская мусульманская одежда, повседневная одежда и тропический халяль-уход за кожей.",
    "page.home.placeholderNote": "Разделы витрины скоро появятся.",
    "nav.newArrivals": "Новинки",
    "nav.bestSellers": "Бестселлеры",
    "nav.sale": "Распродажа",
    "nav.uniqloProducts": "Товары UNIQLO",
    "search.browseCategories": "Просмотр категорий",
    "home.shopByCategory": "Покупки по категориям",
    "home.shopByDepartment": "Покупки по отделам",
    "home.newArrivals": "Новинки",
    "home.bestSellers": "Бестселлеры",
    "home.viewAll": "Смотреть все",
    "home.shopNow": "Купить сейчас",
    "home.allDepartments": "Все отделы",
    "home.deptCta": "Открыть",
    "plp.results": "Результаты: {count} товаров",
    "plp.sortBy": "Сортировка",
    "plp.filter": "Фильтр",
    "product.new": "НОВИНКА",
    "product.sale": "СКИДКА",
    "product.catalog": "КАТАЛОГ",
    "product.catalogLabel": "Предзаказ",
    "preorder.label": "Предзаказ · ориентировочно 2–3 недели",
    "preorder.sizeAvailability": "Размер зависит от наличия на момент заказа",
    "preorder.sizeAvailabilityShort": "Доступность размера зависит от наличия на момент заказа",
    "product.wishlist": "В избранное",
    "footer.account": "Аккаунт",
    "footer.link.myAccount": "Мой аккаунт",
    "footer.link.orders": "Заказы",
    "footer.promo": "",
    "editorial.title": "Истории и гиды",
    "editorial.cta": "Подробнее",
    "page.title.search": "Поиск",
    "page.title.shop": "Магазин",
    "plp.filters": "Фильтры",
    "plp.price": "Цена",
    "plp.minPrice": "Мин",
    "plp.maxPrice": "Макс",
    "plp.apply": "Применить",
    "plp.color": "Цвет",
    "plp.size": "Размер",
    "plp.volume": "Объём",
    "plp.motif": "Узор",
    "plp.format": "Формат",
    "plp.availability": "Режим заказа",
    "plp.inStock": "Предзаказ",
    "plp.clearFilters": "Сбросить все",
    "plp.noResults": "По выбранным фильтрам ничего не найдено.",
    "plp.noProducts": "Коллекция готовится.",
    "plp.noProductsHint": "Посмотрите категории выше. Товары появятся здесь после подготовки коллекции.",
    "plp.noResultsHint": "Попробуйте убрать фильтр или выбрать другие параметры.",
    "plp.pageOf": "Страница {page} из {pages}",
    "plp.prev": "Назад",
    "plp.next": "Вперёд",
    "sort.featured": "Рекомендуемые",
    "sort.newest": "Новинки",
    "sort.priceAsc": "Цена: по возрастанию",
    "sort.priceDesc": "Цена: по убыванию",
    "product.outOfStock": "Доступно по предзаказу",
    "product.lowStock": "Доступно по предзаказу",
    "search.resultsFor": "Результаты по запросу \"{q}\"",
    "search.noResults": "Ничего не найдено. Попробуйте другой запрос.",
    "search.resultsCount": "{count} товаров",
    "page.title.product": "Товар",
    "pdp.quantity": "Количество",
    "pdp.addToCart": "В корзину",
    "pdp.addToWishlist": "В избранное",
    "pdp.catalogNotice": "Предзаказ · ориентировочно 2–3 недели",
    "pdp.sizeGuide": "Таблица размеров",
    "pdp.sizeGuideNote": "Измерения в см. Если вы между размерами, рекомендуем взять больший.",
    "pdp.chest": "Грудь",
    "pdp.length": "Длина",
    "options.color": "Цвет",
    "options.size": "Размер",
    "options.material": "Материал",
    "options.volume": "Объём",
    "options.motif": "Узор",
    "options.format": "Формат",
    "product.inStock": "Предзаказ · ориентировочно 2–3 недели",
    "pdp.onlyLeft": "Предзаказ · ориентировочно 2–3 недели",
    "pdp.description": "Описание",
    "pdp.features": "Характеристики",
    "pdp.materialCare": "Материал и уход",
    "pdp.details": "Детали товара",
    "pdp.ingredients": "Состав",
    "pdp.benefits": "Преимущества",
    "pdp.directions": "Применение",
    "pdp.fragrance": "Аромат",
    "pdp.fragranceFamily": "Семейство ароматов",
    "pdp.notes": "Ноты",
    "pdp.usage": "Способ применения",
    "pdp.alcoholFree": "Формула без спирта",
    "pdp.motif": "Узор",
    "pdp.halalCertified": "Халяль-сертифицировано",
    "pdp.skinType": "Тип кожи",
    "pdp.sku": "Артикул",
    "pdp.selectionReady": "Вариант выбран — корзина появится на следующем этапе.",
    "auth.login": "Войти",
    "auth.register": "Создать аккаунт",
    "auth.email": "Email",
    "auth.password": "Пароль",
    "auth.firstName": "Имя",
    "auth.lastName": "Фамилия",
    "auth.forgot": "Забыли пароль?",
    "auth.noAccount": "Нет аккаунта?",
    "auth.haveAccount": "Уже есть аккаунт?",
    "auth.logout": "Выйти",
    "auth.forgotTitle": "Сброс пароля",
    "auth.forgotText": "Введите email аккаунта — мы отправим ссылку для сброса.",
    "auth.forgotSent": "Если email зарегистрирован, ссылка для сброса отправлена.",
    "auth.sendLink": "Отправить ссылку",
    "auth.resetTitle": "Новый пароль",
    "auth.newPassword": "Новый пароль",
    "auth.resetCta": "Сбросить пароль",
    "auth.resetDone": "Пароль обновлён. Теперь вы можете войти.",
    "auth.backToLogin": "Вернуться ко входу",
    "auth.invalidCredentials": "Неверный email или пароль.",
    "auth.adminOnly": "Для этого аккаунта вход выполняется через Admin Console.",
    "auth.customerOnly": "Эта учётная запись не имеет доступа к магазину для покупателей.",
    "auth.sessionExpired": "Срок действия сеанса истёк. Войдите снова.",
    "auth.emailExists": "Аккаунт с этим email уже существует.",
    "auth.tooMany": "Слишком много попыток. Попробуйте позже.",
    "auth.invalidReset": "Ссылка недействительна или истекла.",
    "auth.genericError": "Что-то пошло не так. Попробуйте ещё раз.",
    "auth.account": "Мой аккаунт",
    "auth.profile": "Профиль",
    "auth.addresses": "Адреса",
    "auth.addAddress": "Добавить адрес",
    "auth.setDefault": "Сделать основным",
    "auth.defaultBadge": "Основной",
    "auth.label": "Метка",
    "auth.recipient": "Имя получателя",
    "auth.phone": "Телефон",
    "auth.addressLine1": "Адрес, строка 1",
    "auth.addressLine2": "Адрес, строка 2 (необязательно)",
    "auth.city": "Город",
    "auth.province": "Область / регион",
    "auth.postalCode": "Индекс",
    "auth.country": "Код страны",
    "auth.localeLabel": "Предпочитаемый язык",
    "auth.profileSaved": "Профиль обновлён.",
    "auth.addressSaved": "Адрес сохранён.",
    "auth.addressDeleted": "Адрес удалён.",
    "auth.loginRequired": "Войдите, чтобы просмотреть аккаунт.",
    "auth.noAddresses": "Нет сохранённых адресов.",
    "auth.memberSince": "Участник с",
    "cart.title": "Корзина",
    "cart.empty": "Ваша корзина пуста",
    "cart.emptyHint": "Посмотрите отделы и добавьте понравившиеся товары.",
    "cart.emptyCta": "Продолжить покупки",
    "cart.subtotal": "Промежуточный итог",
    "cart.remove": "Удалить",
    "cart.checkout": "Перейти к оформлению",
    "cart.checkoutUnavailable": "Онлайн-покупка пока недоступна",
    "cart.checkoutUnavailableBody": "Вы можете добавлять товары в корзину и проверять количество. Онлайн-оформление пока недоступно.",
    "cart.shippingNote": "Администратор подтвердит стоимость доставки в Telegram.",
    "cart.confirm": "Подтвердить",
    "cart.confirmNote": "Это отправит запрос по корзине в чат магазина в Telegram. Нажмите «Отправить» в Telegram. Это ещё не окончательный заказ.",
    "cart.confirmUnavailable": "Запрос корзины через Telegram сейчас недоступен. Попробуйте позже.",
    "cart.confirmFailed": "Не удалось определить, подготовлен ли запрос для Telegram. Обновите корзину и попробуйте снова.",
    "cart.confirmCartChanged": "Этих товаров больше нет в корзине на сервере. Корзина обновлена; добавьте товары снова, если хотите заказать.",
    "cart.confirmRateLimited": "Слишком много попыток. Подождите немного и попробуйте снова.",
    "cart.added": "Добавлено в корзину",
    "cart.exceedsStock": "Предзаказ · ориентировочно 2–3 недели",
    "cart.demoQuantityLimit": "Максимум {count} единиц на товар.",
    "cart.quantityLimit": "Максимум {count} единиц на товар.",
    "cart.sizeNoLongerAvailable": "Этот размер больше недоступен для новых заказов. Товар уже в корзине можно отправить.",
    "cart.mergeAdjusted": "Гостевая корзина объединена.",
    "cart.mergeFailed": "Не удалось объединить гостевую корзину. Она сохранена; попробуйте ещё раз здесь.",
    "cart.mergePending": "Корзина объединяется. Подождите, прежде чем менять товары.",
    "wishlist.title": "Моё избранное",
    "wishlist.empty": "Список избранного пуст",
    "wishlist.emptyHint": "Нажмите на сердечко на товаре, чтобы сохранить его.",
    "wishlist.added": "Добавлено в избранное",
    "wishlist.removed": "Удалено из избранного",
    "wishlist.loginRequired": "Войдите, чтобы сохранять товары в избранное.",
    "wishlist.saveAfterLoginFailed": "Вы вошли, но товар не сохранился. Попробуйте ещё раз.",
    "checkout.title": "Оформление заказа",
    "checkout.contact": "Контакт",
    "checkout.email": "Email",
    "checkout.shippingAddress": "Адрес доставки",
    "checkout.savedAddresses": "Сохранённые адреса",
    "checkout.newAddress": "Использовать новый адрес",
    "checkout.shippingMethod": "Способ доставки",
    "checkout.paymentMethod": "Способ оплаты",
    "checkout.orderSummary": "Ваш заказ",
    "checkout.subtotal": "Подытог",
    "checkout.shipping": "Доставка",
    "checkout.free": "Бесплатно",
    "checkout.total": "Итого",
    "checkout.placeOrder": "Оформить заказ",
    "checkout.placing": "Оформляем…",
    "checkout.empty": "Ваша корзина пуста",
    "checkout.emptyCta": "Вернуться в корзину",
    "checkout.etaDays": "{days} раб. дн.",
    "checkout.stockError": "Некоторые товары недоступны. Проверьте корзину.",
    "checkout.failed": "Не удалось оформить заказ. Попробуйте ещё раз.",
    "checkout.disabledTitle": "Онлайн-покупка пока недоступна",
    "checkout.disabledBody": "Магазин уже работает, но оформление заказа временно приостановлено до настройки способа оплаты. Заказы и платежи не создаются.",
    "checkout.disabledCta": "Вернуться в каталог",
    "pdp.checkoutUnavailable": "Скоро будет доступно",
    "paymentPending.title": "Платёж подтверждается",
    "paymentPending.body": "Заказ зарезервирован, пока мы ждём подтверждения платёжного провайдера. Статус проверяется автоматически.",
    "paymentPending.failedTitle": "Платёж не завершён",
    "paymentPending.failedBody": "Успешный платёж не зарегистрирован. Вернитесь в магазин и попробуйте снова.",
    "paymentPending.invalidTitle": "Статус заказа недоступен",
    "paymentPending.invalidBody": "Ссылка на статус платежа недействительна или устарела.",
    "confirm.title": "Заказ подтверждён",
    "confirm.thanks": "Спасибо! Ваш заказ подтверждён.",
    "confirm.orderNumber": "Номер заказа",
    "confirm.totalPaid": "Оплачено",
    "confirm.emailNote": "Подтверждение записано для {email} (mock email в разработке).",
    "confirm.saveLink": "Сохраните эту страницу, чтобы вернуться к статусу заказа.",
    "confirm.continue": "Продолжить покупки",
    "confirm.viewOrders": "Мои заказы",
    "orders.title": "Мои заказы",
    "orders.empty": "Пока нет заказов",
    "orders.emptyHint": "Ваши завершённые заказы появятся здесь.",
    "orders.items": "{count} тов.",
    "orders.detailTitle": "Заказ",
    "orders.paymentState": "Оплата",
    "orders.orderStatus": "Статус",
    "orders.shippingAddress": "Адрес доставки",
    "orders.shippingMethod": "Способ доставки",
    "orders.subtotal": "Подытог",
    "orders.shipping": "Доставка",
    "orders.total": "Итого",
    "orders.backToOrders": "Ко всем заказам",
    "orders.state.pending_payment": "Ожидает оплаты",
    "orders.state.paid": "Предзаказ в обработке",
    "orders.state.cancelled": "Отменён",
    "orders.state.processing": "В обработке",
    "orders.state.shipped": "Отправлен",
    "orders.state.delivered": "Доставлен",
    "orders.pay.unpaid": "Не оплачен",
    "orders.pay.paid": "Оплачен",
    "orders.pay.failed": "Ошибка",
    "orders.pay.cancelled": "Отменён",
    "orders.pay.expired": "Истёк",
    "orders.pay.refunded": "Возвращён",
    "orders.pay.review": "На проверке",
    "orders.pay.reconciliation_required": "Требует проверки",
    "paymentPending.reviewTitle": "Платёж требует проверки",
    "paymentPending.reviewBody": "Провайдер сообщил о платеже, требующем ручной сверки. Заказ обновится после проверки.",
    "orders.state.payment_review": "Проверка оплаты",
    "orders.state.supplier_shipping": "Отправлено администратору магазина",
    "orders.state.received_by_admin": "Получено администратором магазина",
    "orders.state.customer_shipping": "Отправлено вам",
    "orders.timeline": "Статус заказа",
    "orders.expectedBy": "Ожидаемая дата",
    "seller.portal": "Портал продавца",
    "seller.backToStore": "В магазин",
    "seller.forbidden": "Раздел доступен только аккаунтам продавцов.",
    "seller.nav.dashboard": "Дашборд",
    "seller.nav.products": "ТОВАРЫ",
    "seller.nav.productsList": "Товары",
    "seller.nav.inventory": "Склад",
    "seller.nav.orders": "ЗАКАЗЫ",
    "seller.nav.ordersList": "Заказы",
    "seller.nav.account": "АККАУНТ",
    "seller.nav.profile": "Профиль продавца",
    "seller.dashboard.title": "Дашборд",
    "seller.dashboard.activeProducts": "Активные товары",
    "seller.dashboard.lowStock": "Варианты с низким остатком",
    "seller.dashboard.outOfStock": "Нет в наличии",
    "seller.dashboard.needsAction": "Элементы, требующие действий",
    "seller.dashboard.salesTotal": "Сумма продаж (позиции заказов)",
    "seller.dashboard.salesOrders": "Оплаченные заказы",
    "seller.dashboard.salesNote": "Сумма позиций заказов — не доступный к выводу баланс.",
    "seller.dashboard.recentOrders": "Последние заказы",
    "seller.dashboard.viewAll": "Все",
    "seller.dashboard.paymentReview": "Платежи",
    "seller.dashboard.openInquiries": "Открытые запросы",
    "seller.dashboard.preordersInProgress": "Предзаказы в работе",
    "seller.dashboard.ordersByStatus": "Статусы workflow",
    "seller.dashboard.order": "Заказ",
    "seller.dashboard.date": "Дата",
    "seller.dashboard.status": "Статус",
    "seller.dashboard.payment": "Оплата",
    "seller.dashboard.total": "Итого",
    "seller.dashboard.noRecentOrders": "Недавних заказов нет.",
    "seller.dashboard.errorTitle": "Не удалось загрузить дашборд",
    "seller.dashboard.errorDescription": "Данные дашборда не загрузились. Каталог и заказы не изменены.",
    "seller.dashboard.retry": "Повторить",
    "seller.dashboard.status.inquiry": "Запрос",
    "seller.dashboard.status.payment": "Оплата",
    "seller.dashboard.status.pending_payment": "Ожидает оплаты",
    "seller.dashboard.status.payment_review": "Проверка оплаты",
    "seller.dashboard.status.paid": "Оплачено",
    "seller.dashboard.status.supplier_shipping": "Отправка поставщиком",
    "seller.dashboard.status.received_by_admin": "Получено администратором",
    "seller.dashboard.status.customer_shipping": "Отправка клиенту",
    "seller.dashboard.status.delivered": "Завершено",
    "seller.products.title": "Товары",
    "seller.products.new": "Новый товар",
    "seller.products.searchPlaceholder": "Поиск по вашим товарам…",
    "seller.products.status": "Статус",
    "seller.products.allStatuses": "Все статусы",
    "seller.products.inventory": "Склад",
    "seller.products.allInventory": "Весь склад",
    "seller.products.empty": "Товары не найдены.",
    "seller.products.product": "Товар",
    "seller.products.price": "Цена",
    "seller.products.variants": "Варианты",
    "seller.products.stock": "Остаток",
    "seller.products.edit": "Изменить",
    "seller.products.prev": "Назад",
    "seller.products.next": "Вперёд",
    "seller.stock.in_stock": "В наличии",
    "seller.stock.low_stock": "Мало",
    "seller.stock.out_of_stock": "Нет в наличии",
    "seller.status.active": "Активен",
    "seller.status.draft": "Черновик",
    "seller.status.inactive": "Неактивен",
    "seller.editor.backToProducts": "К товарам",
    "seller.editor.createTitle": "Новый товар",
    "seller.editor.editTitle": "Редактировать товар",
    "seller.editor.basics": "Основное",
    "seller.editor.category": "Категория",
    "seller.editor.type": "Тип товара",
    "seller.editor.brand": "Бренд",
    "seller.editor.basePrice": "Базовая цена",
    "seller.editor.compareAt": "Цена до скидки",
    "seller.editor.status": "Статус",
    "seller.editor.imageUrl": "URL изображения",
    "seller.editor.mediaHint": "Загружайте изображения товара здесь; они сохраняются в локальной медиатеке CMS.",
    "seller.editor.translations": "Переводы",
    "seller.editor.name": "Название",
    "seller.editor.shortDesc": "Краткое описание",
    "seller.editor.description": "Описание",
    "seller.editor.variants": "Варианты",
    "seller.editor.addVariant": "Добавить вариант",
    "seller.editor.optionsHint": "Опции в формате key=value через запятую (напр. color=Black, size=M или volume=50 ml).",
    "seller.editor.sku": "SKU",
    "seller.editor.options": "Опции",
    "seller.editor.stock": "Остаток",
    "seller.editor.priceOverride": "Особая цена",
    "seller.editor.saleOverride": "Акционная цена",
    "seller.editor.active": "Активен",
    "seller.editor.save": "Сохранить",
    "seller.editor.saving": "Сохраняем…",
    "seller.editor.saved": "Товар сохранён.",
    "seller.editor.failed": "Не удалось сохранить. Попробуйте ещё раз.",
    "seller.editor.skuExists": "Такой SKU уже занят. SKU должны быть глобально уникальны.",
    "seller.editor.reservationFloor": "Нельзя установить остаток ниже {count} — есть активные резервы оформления.",
    "seller.editor.archive": "В архив",
    "seller.editor.archived": "Товар архивирован.",
    "seller.inventory.title": "Склад",
    "seller.inventory.hint": "Только физический остаток. Активные резервы оформления управляются системой и не редактируются.",
    "seller.inventory.physical": "Физически",
    "seller.inventory.reserved": "Зарезервировано",
    "seller.inventory.available": "Доступно",
    "seller.inventory.save": "Сохранить",
    "seller.inventory.updated": "Остаток обновлён.",
    "seller.inventory.failed": "Не удалось обновить остаток.",
    "seller.inventory.floorError": "Нельзя ниже {count} — есть активные резервы оформления.",
    "seller.orders.title": "Заказы",
    "seller.orders.allFulfillments": "Все статусы выполнения",
    "seller.orders.order": "Заказ",
    "seller.orders.date": "Дата",
    "seller.orders.recipient": "Получатель",
    "seller.orders.items": "Позиции",
    "seller.orders.payment": "Оплата",
    "seller.orders.fulfillment": "Выполнение",
    "seller.orders.subtotal": "Ваш подытог",
    "seller.orders.empty": "Заказов пока нет.",
    "seller.fulfillment.pending": "Ожидает",
    "seller.fulfillment.processing": "В обработке",
    "seller.fulfillment.shipped": "Отправлен",
    "seller.fulfillment.delivered": "Доставлен",
    "seller.fulfillment.cancelled": "Отменён",
    "seller.orderDetail.items": "Ваши позиции",
    "seller.orderDetail.actions": "Выполнение",
    "seller.orderDetail.blockedUnpaid": "Оплата не подтверждена — выполнение заблокировано до оплаты заказа.",
    "seller.orderDetail.mark_processing": "Начать обработку",
    "seller.orderDetail.mark_shipped": "Отметить отправленным",
    "seller.orderDetail.mark_delivered": "Отметить доставленным",
    "seller.orderDetail.noActions": "Больше нет действий.",
    "seller.orderDetail.carrier": "Перевозчик",
    "seller.orderDetail.trackingNumber": "Трек-номер",
    "seller.orderDetail.customer": "Получатель и доставка",
    "seller.orderDetail.updated": "Выполнение обновлено.",
    "seller.orderDetail.invalidTransition": "Такой переход статуса не разрешён.",
    "seller.orderDetail.failed": "Действие не выполнено. Попробуйте ещё раз.",
    "seller.profile.title": "Профиль продавца",
    "seller.profile.storeName": "Название магазина",
    "seller.profile.phone": "Контактный телефон",
    "seller.profile.description": "Описание магазина",
    "seller.profile.email": "Email аккаунта",
    "seller.profile.slug": "Слаг магазина",
    "seller.profile.memberSince": "На платформе с",
    "seller.profile.save": "Сохранить профиль",
    "seller.profile.saved": "Профиль сохранён.",
    "page.title.cart": "Корзина",
    "page.title.wishlist": "Избранное",
    "page.title.account": "Аккаунт",
    "page.title.checkout": "Оформление заказа",
    "page.title.seller": "Продавец",
    "page.title.admin": "Администрирование",
  },
};
